<div class="block--content block" id="main-content">
    <ridango-page-content-wrapper>
        <rwidget-alert></rwidget-alert>

        <div class="ticket">
            <div class="card-list-table">
                <rwidget-related-cards-list-header
                    *ngIf="
                        (emailTickets$ | async)?.length !== 0 ||
                        (relatedCards$ | async)?.length !== 0 ||
                        (vouchers$ | async)?.length !== 0
                    "></rwidget-related-cards-list-header>

                <rwidget-related-cards-empty-state
                    *ngIf="
                        (relatedCardsLoaded$ | async) &&
                        (relatedCards$ | async)?.length === 0 &&
                        (ticketsLoaded$ | async) &&
                        (vouchers$ | async)?.length === 0 &&
                        (emailTickets$ | async)?.length !== 0
                    ">
                </rwidget-related-cards-empty-state>

                <rwidget-empty-state
                    *ngIf="
                        (ticketsLoaded$ | async) &&
                        (relatedCardsLoaded$ | async) &&
                        (emailTickets$ | async)?.length === 0 &&
                        (relatedCards$ | async)?.length === 0 &&
                        (vouchers$ | async)?.length === 0
                    "
                    [title]="'TRAVELCARD_EMPTY_STATE_TITLE'"
                    [description]="'TRAVELCARD_EMPTY_STATE_DESCRIPTION'">
                    <a
                        class="flex-center width-220 btn btn--primary btn--big link--no-line dark:text-contrast-black"
                        [routerLink]="(env.ENABLE_PURCHASE_V2 ? '/purchase-v2' : '/purchase/ticket') | localize"
                        tabindex="0">
                        {{ 'HEADER_PERIOD_TICKETS' | translate }}
                    </a>

                    <a
                        class="flex-center width-220 btn btn--primary btn--big link--no-line dark:text-contrast-black"
                        [routerLink]="'add' | localize"
                        tabindex="0">
                        {{ 'ADD_TRAVEL_CARD' | translate }}
                    </a>
                </rwidget-empty-state>

                <div class="card-list-table-area table w-full">
                    <rwidget-related-cards-list (onCardSelected)="cardSelected($event)"></rwidget-related-cards-list>

                    <rwidget-voucher-tickets (onVoucherSelected)="voucherSelected($event)"></rwidget-voucher-tickets>
                </div>

                <rwidget-account-email-tickets> </rwidget-account-email-tickets>
            </div>
        </div>
    </ridango-page-content-wrapper>
</div>
